module.exports = __webpack_public_path__ + "static/media/chair.f112c368.png";